var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnBound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9065 19.9999H5.86647C3.4398 19.9999 1.89313 17.4 3.06646 15.2666L6.17313 9.61326L9.0798 4.31992C10.2931 2.11992 13.4665 2.11992 14.6798 4.31992L17.5998 9.61326L18.9998 12.1599L20.7065 15.2666C21.8798 17.4 20.3331 19.9999 17.9065 19.9999Z",
    fill: "#2A2B28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.3333 20.6667C29.3333 25.4533 25.4533 29.3333 20.6667 29.3333C15.88 29.3333 12 25.4533 12 20.6667C12 20.44 12.0133 20.2267 12.0267 20H17.9067C20.3333 20 21.88 17.4 20.7067 15.2667L19 12.16C19.5333 12.0533 20.0933 12 20.6667 12C25.4533 12 29.3333 15.88 29.3333 20.6667Z",
    fill: "#2A2B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnBound);
export default __webpack_public_path__ + "static/media/un-bound.b0625e1876231dbde5eb157ee1646fb0.svg";
export { ForwardRef as ReactComponent };